import styled from 'styled-components';
import { rem } from 'polished';
import { fontFamily } from '@whitelabel/helpers/style/type';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';

interface StyledTrustpilotBlockProps {
  $size?: 'sm' | 'lg';
}

export const StyledTrustpilotBlock = styled.div<StyledTrustpilotBlockProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${rem(4)} ${rem(8)};
  border-radius: 0.5rem;

  .logo {
    img {
      width: ${(props) => (props.$size === 'lg' ? rem(79) : rem(64))};
    }
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .stars {
    img {
      width: ${(props) => (props.$size === 'lg' ? rem(120) : rem(81))};
    }
    margin-inline: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .separator {
    margin-inline: 0.5rem;
  }

  .reviews span {
    font-size: ${(props) => (props.$size === 'lg' ? rem(16) : rem(12))};
    font-family: ${fontFamily('base')};
    text-align: center;
    ${mediaBreakpointUp('sm')`
    flex-basis: content;
  `}
  }
`;
